import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaMicroscope } from 'react-icons/fa6';
import ActionCard from '../../Layouts/ActionCard';
import { clearModelName, selectModelName, setModelName } from '../../Store/imageSlice'; // <-- Make sure this import is correct for your setup
import classNames from 'classnames';

const data = [
    {
        name: "Lung",
        options: [
            {
                name: "SCC",
                model: "lung-tumor-detection",
            },
            {
                name: "Adenocarinoma",
                model: "lung-adenocarcinoma",
            }
        ],
    },
    {
        name: "Colon",
        model: "colon-crc",
    },
    {
        name: "Breast",
        options: [
            {
                name: "IDC",
                model: "breast-idc"
            }
        ]
    }
];

type item = {
    name: string
    model: string
}
type parentItem = {
    name: string
    options?: item[]
    model?: string
}

export default function ImageAnalyzeButtons() {
    const dispatch = useDispatch();

    // Track which top-level item is selected. We store the name to identify it.
    const [selectedParent, setSelectedParent] = useState<parentItem | null>(null);
    const modelName = useSelector(selectModelName)
    console.log("model name selected", modelName)

    useEffect(()=>{
        return () => {
            // dispatch(clearModelName())
        }
    }, [])

    const handleParentClick = (item: any) => {
        if (item.options && item.options.length > 0) {
            // If this parent has options, select it to show its options.
            setSelectedParent(item);
        } else {
            // If no options, dispatch setModelName immediately.
            if (item.model) {
                setSelectedParent(item);
                dispatch(setModelName(item.model));
            }
        }
    };

    const handleOptionClick = (option: any) => {
        // When option is selected, dispatch the model.
        if (option.model) {
            dispatch(setModelName(option.model));
        }
    };

    const getCardStyle = (selected: boolean) => {
        return classNames({
            "border-blue-700": selected,
            "border-gray-700": !selected,
        }, "border-4 cursor-pointer")
    }

    return (
        <div className="container mx-auto p-4">
            <div className="grid grid-cols-4 gap-4">
                {data.map((item) => (
                    <React.Fragment key={item.name}>
                        {/* Top-level ActionCard */}
                        <ActionCard
                            title={item.name}
                            icon={<FaMicroscope />}
                            className={getCardStyle(selectedParent?.name === item.name)}
                            onClick={() => handleParentClick(item)}
                        />
                    </React.Fragment>
                ))}
            </div>
            {selectedParent && selectedParent.options && (
                <div className="col-span-4 grid grid-cols-4 gap-4 mt-2">
                    {selectedParent.options.map((option: any) => (
                        <ActionCard
                            key={option.name}
                            title={option.name}
                            icon={<FaMicroscope />}
                            className={getCardStyle(modelName === option.model)}
                            onClick={() => handleOptionClick(option)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
